"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardTypeE = exports.NFT_API_URLS = void 0;
var NFT_API_URLS;
(function (NFT_API_URLS) {
    NFT_API_URLS["SEARCH"] = "/v2/nft/search";
    NFT_API_URLS["GET_SC_ADDRESS"] = "/v2/nft/get-sc-address";
    NFT_API_URLS["LIST_MY"] = "/v2/nft/get-mine";
    NFT_API_URLS["LIST_CREATED"] = "/v2/nft/get-created";
    NFT_API_URLS["LIST_COLLECTED"] = "/v2/nft/get-collected";
    NFT_API_URLS["GET_HISTORY"] = "/v2/nft/get-history";
    NFT_API_URLS["GET_ACTIVE_OWNERS"] = "/v2/nft/get-active-owners";
    NFT_API_URLS["GET_NFTS_BY_USER"] = "v2/nft/get-by-user";
    NFT_API_URLS["DELETE_NFT"] = "/v2/nft/delete";
    NFT_API_URLS["CONTACT_OWNER"] = "/v2/contact/owner";
    NFT_API_URLS["GET_INFO"] = "/v2/nft/get-info";
    NFT_API_URLS["GET_INFO_BY_IDS"] = "/v2/nft/get-info-by-ids";
    NFT_API_URLS["CREATE_NFT"] = "/v2/nft/create";
    NFT_API_URLS["UPDATE"] = "/v2/nft/update";
    NFT_API_URLS["GET_HIGHLIGHTS"] = "/v2/nft/highlights";
    NFT_API_URLS["GET_BY_FILTER"] = "/v2/nft/get-by-filter";
    NFT_API_URLS["GET_BY_LAUNCHPAD"] = "/v2/nft/get-by-launchpad";
    NFT_API_URLS["LOCK_NFT"] = "/v2/nft/lock-nft";
})(NFT_API_URLS = exports.NFT_API_URLS || (exports.NFT_API_URLS = {}));
var StandardTypeE;
(function (StandardTypeE) {
    StandardTypeE["SINGLE"] = "erc721";
    StandardTypeE["MULTIPLE"] = "erc1155";
})(StandardTypeE = exports.StandardTypeE || (exports.StandardTypeE = {}));
